import "../../../styles/createAccount.css";
import { useEffect } from "react";
import { AuthServices } from "../services/AuthServices";
import { IoCheckmark } from "react-icons/io5";

const ProgressStepDocuments = () => {
  const updateApprovalStatus = async () => {
    await AuthServices.updateApprovalStatus("pending_approval");
  };

  useEffect(() => {
    updateApprovalStatus();  
  }, []);

  return (
    <div className="address-container">
      <IoCheckmark
        size={60}
        style={{
          backgroundColor: "orange",
          borderRadius: "20px",
          padding: "10px",
        }}
      />
      <h2>That's all for now!</h2>
      <p>
        Your account has been submitted for review. Please allow 24-48 hours for
        your approval.
      </p>
    </div>
  );
};

export default ProgressStepDocuments;
